var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { NumberField, ReferenceField, Show, TextField, useRecordContext } from "react-admin";
import { ListDocument } from "./ListDocument";
import { JsonField } from "react-admin-json-view";
import { useQuery } from "@apollo/client";
import { FETCH_DOCUMENT } from "../../queries/FetchDocument";
import { CircularProgress } from "@mui/material";
import { downloadUrl } from "@sequentech/ui-core";
var downloading = false;
var PerformDownload = function (_a) {
    var _b;
    var onDownload = _a.onDownload;
    var record = useRecordContext();
    var _c = useQuery(FETCH_DOCUMENT, {
        variables: {
            electionEventId: record.election_event_id,
            documentId: record.id,
        },
    }), loading = _c.loading, error = _c.error, data = _c.data;
    console.log("is downloading ".concat(downloading));
    if (!loading && !error && ((_b = data === null || data === void 0 ? void 0 : data.fetchDocument) === null || _b === void 0 ? void 0 : _b.url) && !downloading) {
        downloading = true;
        console.log("downloading");
        downloadUrl(data.fetchDocument.url, record.name || "report.pdf").then(function () { return onDownload(); });
    }
    return _jsx(CircularProgress, {});
};
export var DocumentProperties = function () {
    var _a = useState(false), performDownload = _a[0], setPerformDownload = _a[1];
    var downloadDocument = function () {
        setPerformDownload(true);
    };
    return (_jsxs(Box, __assign({ sx: { padding: "16px", display: "flex", flexDirection: "column", gap: "10px" } }, { children: [_jsx(TextField, { source: "name", fontSize: "24px", fontWeight: "bold" }), _jsx(Typography, __assign({ variant: "body1" }, { children: "Media Type" })), _jsx(TextField, { source: "media_type" }), _jsx(Button, __assign({ onClick: downloadDocument }, { children: "Download Document" })), performDownload ? (_jsx(PerformDownload, { onDownload: function () {
                    setPerformDownload(false);
                    downloading = false;
                } })) : null, _jsx(Typography, __assign({ variant: "body1" }, { children: "Size (bytes)" })), _jsx(NumberField, { source: "size" }), _jsx(Typography, __assign({ variant: "body1" }, { children: "Election Event" })), _jsx(ReferenceField, __assign({ source: "election_event_id", reference: "sequent_backend_election_event" }, { children: _jsx(TextField, { source: "name" }) })), _jsx(Typography, __assign({ variant: "body1" }, { children: "Labels" })), _jsx(JsonField, { source: "labels", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } }), _jsx(Typography, __assign({ variant: "body1" }, { children: "Annotations" })), _jsx(JsonField, { source: "annotations", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } })] })));
};
export var ShowDocument = function () {
    return (_jsx(ListDocument, { aside: _jsx(Show, __assign({ sx: { flexGrow: 2, width: "50%", flexShrink: 0 } }, { children: _jsx(DocumentProperties, {}) })) }));
};
